import React from 'react';
import { Button } from '@mui/material';
import { FormattedMessage } from 'react-intl';
import { SVGS } from '../../../../../../assets/images';
import { Lx } from '../../../../../../i18n/consts';
import styles from './delete-calendar-button.module.scss';

interface DeleteCalendarButtonProps {
    onClick: () => void;
    disabled?: boolean;
}

const DeleteCalendarButton: React.FC<DeleteCalendarButtonProps> = ({ onClick, disabled }) => (
    <Button className={styles.deleteCalendarButton} onClick={onClick} disabled={disabled}>
        <SVGS.DeleteIcon className={styles.icon} />
        <span>
            <FormattedMessage id={Lx.General.DELETE} defaultMessage='Delete' />
        </span>
    </Button>
);

export default React.memo(DeleteCalendarButton);
